module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-buy-243b85873a4186ad34ecd22202532f11.png";